import { keyValuePair } from '../../models/keyVauePair';
import { assets } from './assets.const';

export const encryptionKeys = {
  IV: '9g5y5fdlctdegrtv',
  key: '8pa7aohegahg5j2'
};

export const ROLE_SUB_TYPE = {
  BOOKER: 1,
  MANAGER: 2,
  C_LEVEL: 3,
  STAFF: 4
};

export const ROLE_SUB_TYPE_LABELS = {
  [ROLE_SUB_TYPE.BOOKER]: 'Booking Co-ordinator',
  [ROLE_SUB_TYPE.MANAGER]: 'Manager',
  [ROLE_SUB_TYPE.C_LEVEL]: 'C-level Directors',
  [ROLE_SUB_TYPE.STAFF]: 'Staff'
};

export const Exceeded_Type = {
  DAYS: 1,
  WEEKLY: 2
};

export const PARENT_BOOKING_TYPE = {
  CARS: 1,
  YATCHES: 2,
  VILLA: 3,
  JETS: 4
};

export const SUB_ROLE_ARRAY: keyValuePair[] = [
  {
    key: 'Booking Co-ordinator',
    value: ROLE_SUB_TYPE.BOOKER,
    createdAt:
      'Bookings created by coordinators require approval from the Admin (Owner), Sub-Admins, or their assigned Managers.'
  },
  {
    key: 'C-level Directors',
    value: ROLE_SUB_TYPE.C_LEVEL,
    createdAt:
      'Bookings created by C-level Directors require approval from the Admin (Owner), Sub-Admins'
  },
  {
    key: 'Manager',
    value: ROLE_SUB_TYPE.MANAGER,
    createdAt:
      'Bookings created by managers require approval from the Admin (Owner), Sub-Admins'
  },
  {
    key: 'Staff',
    value: ROLE_SUB_TYPE.STAFF,
    createdAt:
      'Bookings created by staff  require approval from the Admin (Owner), Sub-Admins, or their assigned Managers.'
  }
];

export const CORPORATE_PAYMENT_STATUS = {
  1: 'PENDING',
  2: 'COMPLETED',
  3: 'COMPLETED_BY_ADMIN',
  4: 'OVER_DUE',
  5: 'DUE'
};

export const BOOKING_TYPE = {
  SELF_DRIVING: 1,
  CHAUFFER_RENTAL: 2
};

export const CORPORATE_BOOKING_TYPE = {
  OTHERS: 0,
  CLIENT: 1,
  EMPLOYEE: 2
};

export const ChauffeurBookingTypeLabels: Record<number, string> = {
  [BOOKING_TYPE.SELF_DRIVING]: 'Self Rental',
  [BOOKING_TYPE.CHAUFFER_RENTAL]: 'Chauffeur Rental'
};

export const carUserType = {
  1: 'Individual',
  2: 'Corporate',
  3: 'Both'
} as any;

export interface RouteSidebarConfig {
  parentLabel: string;
  subPath?: string;
}

export interface RouteHeaderConfig {
  heading: string;
  description: string;
  sidebar?: RouteSidebarConfig;
}

export interface RouteShowHeaderEntry {
  label: string;
  value: RouteHeaderConfig;
}

export const routeShowHeader: RouteShowHeaderEntry[] = [
  {
    label: 'dashboard',
    value: {
      heading: 'Welcome Back',
      description: 'date'
    }
  },
  {
    label: 'manage-client',
    value: {
      heading: 'User Management',
      description: 'Manage your clients & employees'
    }
  },
  {
    label: 'manage-employee',
    value: {
      heading: 'User Management',
      description: 'Manage your clients & employees'
    }
  },
  {
    label: 'profile',
    value: {
      heading: 'Profile',
      description: 'Manage Profile and Password'
    }
  },
  {
    label: 'change-password',
    value: {
      heading: 'Profile',
      description: 'Manage Profile and Password'
    }
  },
  {
    label: 'received-notification',
    value: {
      heading: 'Notifications',
      description: 'Stay updated with the latest alerts'
    }
  },
  {
    label: 'subadmin',
    value: {
      heading: 'Users and Roles',
      description: 'Manage users and their roles'
    }
  },
  {
    label: 'manage-analytics',
    value: {
      heading: 'Analytics & Reports',
      description: 'Explore data to uncover spending trends and insights.'
    }
  },
  {
    label: 'contact-us',
    value: {
      heading: 'Help & Support',
      description: 'Contact Details'
    }
  },
  {
    label: 'manage-payouts',
    value: {
      heading: 'Financials',
      description: 'Manage Payments and invoices',
      sidebar: {
        parentLabel: 'Financials',
        subPath: '/manage-payouts'
      }
    }
  },
  {
    label: 'updated-Booking-flow/select-asset',
    value: {
      heading: 'Create a new Booking',
      description: 'Select a service to proceed with your booking.',
      sidebar: {
        parentLabel: 'Bookings',
        subPath: '/updated-Booking-flow'
      }
    }
  },
  {
    label: 'updated-Booking-flow/book-now',
    value: {
      heading: 'Create a new Booking',
      description: 'Select a rental type, date, and vehicle that fits your needs.',
      sidebar: {
        parentLabel: 'Bookings',
        subPath: '/updated-Booking-flow'
      }
    }
  },
  {
    label: 'updated-Booking-flow/fine-and-tolls',
    value: {
      heading: 'All Bookings',
      description: 'Manage all bookings',
      sidebar: {
        parentLabel: 'Bookings',
        subPath: '/manage-bookings/list/1/0/0'
      }
    }
  },
  {
    label: 'manage-teams',
    value: {
      heading: 'Manage Teams',
      description: 'Manage your team settings with ease',
      sidebar: {
        parentLabel: 'Settings',
        subPath: '/manage-teams'
      }
    }
  },
  {
    label: 'manage-config',
    value: {
      heading: 'Role Configurations',
      description: 'Manage role config. & permissions',
      sidebar: {
        parentLabel: 'Settings',
        subPath: '/manage-config'
      }
    }
  },
  {
    label: 'updated-Booking-flow/tracking-page',
    value: {
      heading: 'All Bookings',
      description: 'Manage all bookings',
      sidebar: {
        parentLabel: 'Bookings',
        subPath: '/manage-bookings/list/1/0/0'
      }
    }
  },
  {
    label: 'updated-Booking-flow/updated-Booking-detail',
    value: {
      heading: 'All Bookings',
      description: 'Manage all bookings',
      sidebar: {
        parentLabel: 'Bookings',
        subPath: '/manage-bookings/list/1/0/0'
      }
    }
  },
  {
    label: 'manage-bookings',
    value: {
      heading: 'All Bookings',
      description: 'Manage all bookings',
      sidebar: {
        parentLabel: 'Bookings',
        subPath: '/manage-bookings/list/1/0/0'
      }
    }
  },
  {
    label: 'catalogues',
    value: {
      heading: 'Service Catalogue',
      description: 'Browse all available assets and services.'
    }
  },
  {
    label: 'manage-approvals',
    value: {
      heading: 'Approval Queue',
      description: 'Manage all Approval Queues',
      sidebar: {
        parentLabel: 'Bookings',
        subPath: '/manage-approvals/0'
      }
    }
  },
  {
    label: 'manage-employee/employee',
    value: {
      heading: 'User Management',
      description: 'Manage your clients & employees',
      sidebar: {
        parentLabel: 'User Management',
        subPath: '/manage-employee'
      }
    }
  },
  {
    label: 'manage-employee/type',
    value: {
      heading: 'User Management',
      description: 'Manage your clients & employees',
      sidebar: {
        parentLabel: 'User Management',
        subPath: '/manage-employee'
      }
    }
  },
  {
    label: 'manage-client/type',
    value: {
      heading: 'User Management',
      description: 'Manage your clients & employees',
      sidebar: {
        parentLabel: 'User Management',
        subPath: '/manage-employee'
      }
    }
  },
  {
    label: 'subadmin/add-role',
    value: {
      heading: 'Users and Roles',
      description: 'Manage users and their roles',
      sidebar: {
        parentLabel: 'Manage Sub-Admin',
        subPath: '/subadmin'
      }
    }
  },
  {
    label: 'subadmin/edit-role',
    value: {
      heading: 'Users and Roles',
      description: 'Manage users and their roles',
      sidebar: {
        parentLabel: 'Manage Sub-Admin',
        subPath: '/subadmin'
      }
    }
  }
];

export const gearType = [
  {
    title: 'Manual',
    status: 1,
    icon: assets.gearIcon
  },
  {
    title: 'Automatic',
    status: 2,
    icon: assets.gearIcon
  }
];

export const engineType = [
  {
    title: 'Petrol',
    status: 1,
    icon: assets.engineIcon
  },
  {
    title: 'Diesel',
    status: 2,
    icon: assets.engineIcon
  },
  {
    title: 'Electric',
    status: 4,
    icon: assets.engineIcon
  }
];

export const VERIFICATION_TYPE = {
  SIGNUP: 1,
  LOGIN: 2,
  UPDATE: 3,
  FORGET: 4
};

export const carStatus = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
  DRAFT: 0,
  PENDINGAPPROVAL: 4
} as any;

export const DEFAULT_VALUE = '-----';

export const DocType = {
  Documents: 1,
  KYC: 2
};

export const VehicleType = {
  MyVehicle: 1,
  PlatformVehicle: 2
};

export const OwlOptionsValue = {
  loop: true,
  mouseDrag: false,
  touchDrag: false,
  pullDrag: false,
  dots: false,
  autoplay: true,
  navSpeed: 500,
  navText: ['&#8249', '&#8250;'],
  responsive: {
    0: {
      items: 1
    }
  },
  nav: true
};

export const userType = {
  Client: 1,
  Employee: 2
};

export const values = {
  CHAUFFER_BOOKED: 1,
  CHAUFFER_ON_THE_WAY: 2,
  CHAUFFER_NEAR_BY_LOCATION: 3,
  CHAUFFER_ARRIVE_NOW: 4,
  CHAUFFER_PICKUP_COMPLETED: 5,
  CHAUFFER_PICKUP_INCOMPLETE: 6,
  CHAUFFER_RIDE_STARTED: 7,
  CHAUFFER_RIDE_COMPLETED: 8,
  CHAUFFER_REACHED_GARAGE: 21,
  RENTAL_BOOKED: 9,
  RENTAL_STAGE_ONE_ON_THE_WAY: 10,
  RENTAL_STAGE_ONE_NEAR_BY_LOCATION: 11,
  RENTAL_STAGE_ONE_DROP_OFF_COMPLETED: 12,
  RENTAL_STAGE_TWO_ON_THE_WAY: 13,
  RENTAL_STAGE_TWO_NEAR_BY_LOCATION: 14,
  RENTAL_STAGE_TWO_PICKUP_COMPLETED: 15,
  RENTAL_STAGE_TWO_PICKUP_HEADING_TO_GARAGE: 16,
  RENTAL_STAGE_TWO_REACHED_GARAGE: 17,
  CANCELLED: 18,
  AUTO_CANCEL: 19,
  AUTO_KYC_CANCEL: 20,
  RENTAL_REACHED_GARAGE: 22,
  RENTAL_VEHICLE_PICKUP_COMPLETED: 23,
  RENTAL_VEHICLE_DROP_OFF: 24,
  RENTAL_REACHED_DESTINATION: 25,
  RENTAL_TWO_REACHED_DESTINATION: 26,
  RENTAL_TWO_DROP_OFF_COMPLETED: 27,
  CHAUFFER_HEADING_TO_PICKUP_LOCATION: 28,
  CHAUFFER_REACHED_PICKUP_LOCATION: 29,
  CHAUFFER_HEADING_TP_WAREHOUSE: 30,
  CHAUFFER_VEHICLE_DROP_OFF_COMPLETED: 31,
  RENTAL_BOOKED_DRIVER_ASSIGNED_PENDING: 32
};

export const stageOneStatus = [9, 10, 11, 22, 23, 24, 25, 12];
export const stageTwoStatus = [13, 14, 26, 15, 16, 17, 27];
export const stageTwoDetailsStatus = [12, 13, 14, 26, 15, 16, 17, 27];
export const chaufferBookingStatusNum = [1, 2, 4, 5, 28, 29, 7, 8, 30, 21, 31];
export const liveTrackingStatus = [24, 25, 26, 28, 13, 14, 29]; // 11,23 removed as no need to show tracking for these statuses Sujal.
export const chaufferShowOnlyDriverMovementStatus = [7];
const stageOne = [9, 10, 24, 11, 25, 12];
const stageTwo = [32, 13, 14, 26]; // 15 removing because trip is completed and no need to show S2- in table
const stageThree = [1, 2, 28, 3, 29, 7, 8];
export const activeBookingStatus = [...stageOne, ...stageTwo, ...stageThree];


/* Tracking Page Booking Statuses Of Stage One */
export const bookingStatuses: Array<keyValuePair> = [
  {
    key: 'RENTAL_BOOKED',
    value: values.RENTAL_BOOKED,
    createdAt: '',
    isCompleted: false
  },
  // {
  //   key: 'RENTAL_BOOKED_DRIVER_ASSIGNED_PENDING',
  //   value: values.RENTAL_BOOKED_DRIVER_ASSIGNED_PENDING,
  //   createdAt: '',
  //   isCompleted:false
  // },
  {
    key: 'RENTAL_STAGE_ONE_ON_THE_WAY',
    value: values.RENTAL_STAGE_ONE_ON_THE_WAY,
    createdAt: '',
    isCompleted: false
  },
  // {
  //   key: 'RENTAL_REACHED_GARAGE',
  //   value: values.RENTAL_REACHED_GARAGE,
  //   createdAt: '',
  //   isCompleted:false
  // },
  // {
  //   key: 'RENTAL_VEHICLE_PICKUP_COMPLETED',
  //   value: values.RENTAL_VEHICLE_PICKUP_COMPLETED,
  //   createdAt: '',
  //   isCompleted:false
  // },
  {
    key: 'RENTAL_VEHICLE_DROP_OFF',
    value: values.RENTAL_VEHICLE_DROP_OFF,
    createdAt: '',
    isCompleted: false
  },
  {
    key: 'RENTAL_STAGE_ONE_NEAR_BY_LOCATION',
    value: values.RENTAL_STAGE_ONE_NEAR_BY_LOCATION,
    createdAt: '',
    isCompleted: false
  },
  {
    key: 'RENTAL_REACHED_DESTINATION',
    value: values.RENTAL_REACHED_DESTINATION,
    createdAt: '',
    isCompleted: false
  },
  {
    key: 'RENTAL_STAGE_ONE_DROP_OFF_COMPLETED',
    value: values.RENTAL_STAGE_ONE_DROP_OFF_COMPLETED,
    createdAt: '',
    isCompleted: false
  }
];
/* Tracking Page Booking Statuses Of Stage Two */
export const selfRentalBookingTwoStatuses: Array<keyValuePair> = [
  {
    key: 'RENTAL_BOOKED_DRIVER_ASSIGNED_PENDING',
    value: values.RENTAL_BOOKED_DRIVER_ASSIGNED_PENDING,
    createdAt: '',
    isCompleted: false
  },
  {
    key: 'RENTAL_STAGE_TWO_ON_THE_WAY',
    value: values.RENTAL_STAGE_TWO_ON_THE_WAY,
    createdAt: '',
    isCompleted: false
  },
  {
    key: 'RENTAL_STAGE_TWO_NEAR_BY_LOCATION',
    value: values.RENTAL_STAGE_TWO_NEAR_BY_LOCATION,
    createdAt: '',
    isCompleted: false
  },
  {
    key: 'RENTAL_TWO_REACHED_DESTINATION',
    value: values.RENTAL_TWO_REACHED_DESTINATION,
    createdAt: '',
    isCompleted: false
  },
  {
    key: 'RENTAL_STAGE_TWO_PICKUP_COMPLETED',
    value: values.RENTAL_STAGE_TWO_PICKUP_COMPLETED,
    createdAt: '',
    isCompleted: false
  }
];

export const paymentStatuses: Array<keyValuePair> = [
  {
    key: 'CHAUFFER_BOOKED',
    value: values.CHAUFFER_BOOKED
  },
  {
    key: 'CHAUFFER_ON_THE_WAY',
    value: values.CHAUFFER_ON_THE_WAY
  },
  {
    key: 'CHAUFFER_NEAR_BY_LOCATION',
    value: values.CHAUFFER_NEAR_BY_LOCATION
  },
  {
    key: 'CHAUFFER_ARRIVE_NOW',
    value: values.CHAUFFER_ARRIVE_NOW
  },
  {
    key: 'CHAUFFER_PICKUP_COMPLETED',
    value: values.CHAUFFER_PICKUP_COMPLETED
  },
  {
    key: 'CHAUFFER_PICKUP_INCOMPLETE',
    value: values.CHAUFFER_PICKUP_INCOMPLETE
  },
  {
    key: 'CHAUFFER_RIDE_STARTED',
    value: values.CHAUFFER_RIDE_STARTED
  },
  {
    key: 'CHAUFFER_RIDE_COMPLETED',
    value: values.CHAUFFER_RIDE_COMPLETED
  },
  {
    key: 'CHAUFFER_REACHED_GARAGE',
    value: values.CHAUFFER_REACHED_GARAGE
  },
  {
    key: 'RENTAL_BOOKED',
    value: values.RENTAL_BOOKED
  },
  {
    key: 'RENTAL_STAGE_ONE_ON_THE_WAY',
    value: values.RENTAL_STAGE_ONE_ON_THE_WAY
  },
  {
    key: 'RENTAL_STAGE_ONE_NEAR_BY_LOCATION',
    value: values.RENTAL_STAGE_ONE_NEAR_BY_LOCATION
  },
  {
    key: 'RENTAL_STAGE_ONE_DROP_OFF_COMPLETED',
    value: values.RENTAL_STAGE_ONE_DROP_OFF_COMPLETED
  },
  {
    key: 'RENTAL_STAGE_TWO_ON_THE_WAY',
    value: values.RENTAL_STAGE_TWO_ON_THE_WAY
  },
  {
    key: 'RENTAL_STAGE_TWO_NEAR_BY_LOCATION',
    value: values.RENTAL_STAGE_TWO_NEAR_BY_LOCATION
  },
  {
    key: 'RENTAL_STAGE_TWO_PICKUP_COMPLETED',
    value: values.RENTAL_STAGE_TWO_PICKUP_COMPLETED
  },
  {
    key: 'RENTAL_STAGE_TWO_PICKUP_HEADING_TO_GARAGE',
    value: values.RENTAL_STAGE_TWO_PICKUP_HEADING_TO_GARAGE
  },
  {
    key: 'RENTAL_STAGE_TWO_REACHED_GARAGE',
    value: values.RENTAL_STAGE_TWO_REACHED_GARAGE
  },
  {
    key: 'CANCELLED',
    value: values.CANCELLED
  },
  {
    key: 'AUTO_CANCEL',
    value: values.AUTO_CANCEL
  },
  {
    key: 'AUTO_KYC_CANCEL',
    value: values.AUTO_KYC_CANCEL
  },
  {
    key: 'RENTAL_REACHED_GARAGE',
    value: values.RENTAL_REACHED_GARAGE
  },
  {
    key: 'RENTAL_VEHICLE_PICKUP_COMPLETED',
    value: values.RENTAL_VEHICLE_PICKUP_COMPLETED
  },
  {
    key: 'RENTAL_VEHICLE_DROP_OFF',
    value: values.RENTAL_VEHICLE_DROP_OFF
  },
  {
    key: 'RENTAL_REACHED_DESTINATION',
    value: values.RENTAL_REACHED_DESTINATION
  },
  {
    key: 'RENTAL_TWO_REACHED_DESTINATION',
    value: values.RENTAL_TWO_REACHED_DESTINATION
  },
  {
    key: 'RENTAL_TWO_DROP_OFF_COMPLETED',
    value: values.RENTAL_TWO_DROP_OFF_COMPLETED
  },
  {
    key: 'CHAUFFER_HEADING_TO_PICKUP_LOCATION',
    value: values.CHAUFFER_HEADING_TO_PICKUP_LOCATION
  },
  {
    key: 'CHAUFFER_REACHED_PICKUP_LOCATION',
    value: values.CHAUFFER_REACHED_PICKUP_LOCATION
  },
  {
    key: 'CHAUFFER_HEADING_TP_WAREHOUSE',
    value: values.CHAUFFER_HEADING_TP_WAREHOUSE
  },
  {
    key: 'CHAUFFER_VEHICLE_DROP_OFF_COMPLETED',
    value: values.CHAUFFER_VEHICLE_DROP_OFF_COMPLETED
  }
];

export const mediaType = {
  Image: 1,
  Video: 2,
  Text: 3
};

export const StaticPolicy = {
  cancellationPolicy:
    'You may cancel your booking at no cost up to 48 hours prior to the trip start time. Any last-minute cancellations made within 48 hours will incur the full booking charge.',
  modificationPolicy:
    'Pickup and drop-off locations may be modified only before a valet or chauffeur has been assigned. Once the vehicle is en route for delivery, no further changes can be accommodated.'
};
